module.exports = __webpack_public_path__ + "img/honor.a1ddb4ef.png";